module.exports = __webpack_public_path__ + "static/media/screen5.3367d1c8.png";